
export const IMAGE_TYPE = {
    ABOUT: "about",
    BOOK1: "book1",
    LEISURE: "leisure",
    DETOX : "detox_1",
    WALK: "walk",
    POORTEN: "poorten",
    KERSTBOOM: "kerstboom",
}

export interface Topic {
    imageSrc: string
    type: string
}

export const TOPICS: Topic[] = [
    {
        imageSrc: "./resources/cover.jpg",
        type: IMAGE_TYPE.ABOUT
    },
    {
        imageSrc: "./resources/landloos.jpg",
        type: IMAGE_TYPE.BOOK1
    },
    {
        imageSrc: "./resources/detox.jpg",
        type: IMAGE_TYPE.DETOX
    },
    {
        imageSrc: "./resources/poorten.png",
        type: IMAGE_TYPE.POORTEN
    },
    {
        imageSrc: "./resources/walk.jpg",
        type: IMAGE_TYPE.WALK
    },
    {
        imageSrc: "./resources/kerstboom.jpg",
        type: IMAGE_TYPE.KERSTBOOM
    }




]

